import ConfirmModal from '@components/modal/ConfirmModal';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useEffect } from 'react';
import { AdminUser } from 'src/types/shared/AdminUser';
import useUpgradeAdmin from './hooks/useUpgradeAdmin';

const UpgradeAdminModal: React.FC<DeleteAdminProps> = ({ user, closeModal }) => {
    const { upgradeUser, isPosting, error, upgradeSuccess } = useUpgradeAdmin(user.id);
    const prevSuccess = usePrevious(upgradeSuccess);

    useEffect(() => {
        if (!prevSuccess && upgradeSuccess) closeModal();
    }, [upgradeSuccess, prevSuccess, closeModal]);

    return (
        <ConfirmModal
            title="Upgrade admin"
            description={`Are you sure you want to upgrade '${user.firstName} ${user.lastName}' to Super Admin?`}
            closeModal={closeModal}
            handleSubmit={upgradeUser}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteAdminProps {
    user: AdminUser;
    closeModal: () => void;
}

export default UpgradeAdminModal;
